import { render, staticRenderFns } from "./ShareOrgDialog.vue?vue&type=template&id=5a36d826&scoped=true&"
import script from "./ShareOrgDialog.vue?vue&type=script&lang=js&"
export * from "./ShareOrgDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareOrgDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ShareOrgDialog.vue?vue&type=style&index=1&id=5a36d826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a36d826",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardText,VCardTitle,VChip,VDialog,VExpandTransition,VIcon,VProgressCircular,VSkeletonLoader,VTextField})
